export const colors = {
  primary: {
    100: '#E5F7FF',
    200: '#D0EFFF',
    300: '#AADFFF',
    400: '#429FFF',
    500: '#1874FF',
    600: '#005AFF',
    700: '#005DFF',
    800: '#0052E0',
    900: '#011542', // MAIN
  },
  secondary: {
    100: '#AEFFF7', //MAIN
    200: '#91FEF5',
    300: '#52F6EF',
    400: '#1FE2E0',
    500: '#06C5C6',
    600: '#029B9F',
    700: '#067B7F',
    800: '#0A6165',
    900: '#002F33',
  },
  purple: {
    100: '#FAF6FD',
    200: '#E9D9F5',
    300: '#DABBEC',
    400: '#C592E0',
    500: '#A967CE',
    600: '#8A46AC', //MAIN
    700: '#763992',
    800: '#623078',
    900: '#33133F',
  },
  apricot: {
    100: '#FCEAD8',
    200: '#F8D2B0',
    300: '#F2AB74', // MAIN
    400: '#ED874A',
    500: '#E86827',
    600: '#DA4F1C',
    700: '#B53B19',
    800: '#90301C',
    900: '#3F120B',
  },
  success: {
    100: '#F4FDD0',
    200: '#E7FBA2',
    300: '#D2F473',
    400: '#BCEA4F',
    500: '#9CDD1A',
    600: '#7FBE13',
    700: '#649F0D',
    800: '#4B8008',
    900: '#3A6A04',
  },
  warning: {
    100: '#FFF4D8',
    200: '#FFECAE',
    300: '#FFDE85',
    400: '#FFD167',
    500: '#FFBB35',
    600: '#DB9826',
    700: '#B7771A',
    800: '#935A10',
    900: '#7A450A',
  },
  danger: {
    100: '#FFE4D7',
    200: '#FFC4AF',
    300: '#FF9C87',
    400: '#FF7669"',
    500: '#FF3838',
    600: '#DB2838',
    700: '#B71C37',
    800: '#931133',
    900: '#7A0A31',
  },

  black: {
    100: '#343434',
    200: '#303030',
    300: '#2D2D2D',
    400: '#292929',
    500: '#252525',
    600: '#1D1D1D',
    700: '#161616',
    800: '#0E0E0E',
  },
  neutrals: {
    100: '#FFFFFF',
    200: '#F0F0F0',
    300: '#E0E0E0',
    400: '#D1D1D1',
    500: '#C2C2C2',
    600: '#A3A3A3',
    700: '#858585',
    800: '#666666',
  },
  white: {
    500: '#FFF',
  },
  background: '#0E0E0E',
  text: '#F0F0F0',
  link: '#AEFFF7',
};
